import DataTable from 'react-data-table-component';
import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { Modal, Button, Form } from 'react-bootstrap';

const customStyles = {
    headCells: {
        style: {
            fontSize: '12px', 
        },
    },
    cells: {
        style: {
            fontSize: '12px', 
        },
    },
};

export default class BankTransactions extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'banktransaction',
            data: null,
            loading: true,
            page: 1, // مقداردهی اولیه برای صفحه
            per_page: 10, // مقداردهی اولیه برای تعداد رکوردها در هر صفحه
        };
    }



    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        this.setState({ loading: true });


        fetch(`/api/v1/${this.state.controllerName}/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({}) // بدنه‌ی خالی اضافه شده است
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === -1) {
                    window.location.href = "/login";
                } else if (data.status === -2) {
                    this.setState({
                        data: data,
                        loading: false
                    });
                } else if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(error => {
                console.error('Error:', error);
                this.setState({ loading: false });
            });

    }



    loadBankOptions = (inputValue, callback) => {
        this.httpPost("api/v1/bank/list", { phrase: inputValue, page: 1, count: 10 })
            .then(data => {
                if (data.status === 1) {
                    const options = data.records.map(bank => ({
                        value: bank.id,
                        label: bank.name
                    }));
                    callback(options);
                }
            });
    }
    loadOperationOptions = (inputValue, callback) => {
        this.httpPost("api/v1/operation/list", { phrase: inputValue, page: 1, count: 10 })
            .then(data => {
                if (data.status === 1) {
                    const options = data.records.map(operation => ({
                        value: operation.id,
                        label: operation.name
                    }));
                    callback(options);
                }
            });
    }
    handleBankChange = (selectedOption) => {
        this.setState({ selectedBankId: selectedOption ? selectedOption : null }); 
    }
    handleInputChange = (id, name, value) => {
        this.setState(prevState => {
            const updatedRecords = prevState.data.records.map(row => {
                if (row.id === id) {
                    return { ...row, [name]: value };
                }
                return row;
            });
            return {
                data: {
                    ...prevState.data,
                    records: updatedRecords
                }
            };
        });
    }
    saveChanges = (id, updatedRow) => {

        const body = {
            id: Number(updatedRow.id), // تبدیل به عدد
            companyId: Number(this.state.data.global.company.id), // تبدیل به عدد
            transactionNumber: updatedRow.transactionNumber,
            transactionDate: updatedRow.transactionDate,
            transactionTime: new Date(updatedRow.transactionDate).toISOString().substring(11, 19), // تبدیل زمان تراکنش به TimeSpan
            amount: Number(updatedRow.amount), // تبدیل به عدد
            description: updatedRow.description,
            bankDescription: updatedRow.bankDescription || '', // اضافه کردن bankDescription
            transactionType: Number(updatedRow.transactionType), // تبدیل به عدد
            operationId: Number(updatedRow.operationId), // تبدیل به عدد
            bankId: Number(this.state.selectedBankId.value) // تبدیل به عدد
        };

        this.httpPost(`/api/v1/banktransaction/save`, body)
            .then(data => {
                if (data.status === 1) {
                    this.setState(prevState => {
                        const updatedRecords = prevState.data.records.map(row => {
                            if (row.id === id) {
                                return updatedRow;
                            }
                            return row;
                        });
                        return {
                            data: {
                                ...prevState.data,
                                records: updatedRecords
                            },
                            editingRows: { ...prevState.editingRows, [id]: false }
                        };
                    });
                } else {
                    alert(data.message || "خطایی در زمان اجرا رخ داده است");
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert("خطایی در زمان اجرا رخ داده است");
            });
    }


    handleShowModal = () => {
        this.setState({ showModal: true });
    }
    handleCloseModal = () => {
        this.setState({ showModal: false });
    }
    handleSave = () => {
        console.log("تاریخ:", this.state.date, "دریافت‌کننده:", this.state.receiver);
        this.handleCloseModal();
    }


    renderForm() {
        const columns = [
            {
                name: 'ردیف',
                selector: (row, index) => this.genRowNumber(index),
                center: true,
                sortable: true,
                width: '100px',
            },
            {
                name: 'تاریخ تراکنش',
                selector: row => new Date(row.transactionDate).toLocaleDateString('fa-IR'),
                sortable: true,
                cell: row => new Date(row.transactionDate).toLocaleDateString('fa-IR')
            },
            {
                name: 'نوع تراکنش',
                selector: row => row.transactionType === 0 ? 'دریافت' : 'پرداخت',
                sortable: true,
                cell: row => row.transactionType === 0 ? 'دریافت' : 'پرداخت'
            },
            {
                name: 'شماره تراکنش',
                selector: row => row.transactionNumber,
                sortable: true,
                cell: row => row.transactionNumber
            },
            {
                name: 'مبلغ',
                selector: row => row.amount,
                sortable: true,
                cell: row => {
                    const formattedAmount = row.amount.toLocaleString('fa-IR');
                    return (
                        <span style={{
                            color: row.transactionType === 1 ? 'red' : 'black',
                            fontWeight: row.transactionType === 1 ? 'bold' : 'normal',
                        }}>
                            {row.transactionType === 1 ? `(${formattedAmount})` : formattedAmount}
                        </span>
                    );
                }
            },
            {
                name: 'توضیحات',
                selector: row => row.description,
                sortable: true,
                cell: row => row.description
            },
            {
                name: 'عملیات',
                cell: row => row.operationName,
                sortable: true,
            },
            {
                name: 'ویرایش و ذخیره',
                cell: row => (
                    <ul className="nk-tb-actions gx-1">
                        <li>
                            <div className="drodown">
                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown">
                                    <em className="icon ni ni-more-h"></em>
                                </a>
                                <div className="dropdown-menu dropdown-menu-end">
                                    <ul className="link-list-opt no-bdr">
                                        <li>
                                            <a className="hand" onClick={() => this.confirmRemove(row.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove">
                                                <em className="icon ni ni-na"></em><span>حذف رکورد</span>
                                            </a>
                                        </li>
                                        <li>
                                            <NavLink to={`/banktransaction/edit/${row.id}/`}>
                                                <em className="icon ni ni-eye"></em><span>مشاهده</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                center: true,
            }
        ];


        return (
            <div>
                <div className="nk-content-body">
                    <div className="nk-block-head nk-block-head-sm">
                        <div className="nk-block-between">
                            <div className="nk-block-head-content">
                                <h3 className="nk-block-title page-title">فهرست تراکنش‌های بانکی</h3>
                                <div className="nk-block-des text-soft">
                                    <p>شما {this.state.data.recordsCount} تراکنش ثبت شده دارید</p>
                                </div>
                            </div>
                            <div className="nk-block-head-content">
                                <div className="toggle-wrap nk-block-tools-toggle">
                                    <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                    <div className="toggle-expand-content" data-content="pageMenu">
                                        <ul className="nk-block-tools g-3">
                                            <li>
                                                <a onClick={e => this.getPdfs(e)} className="btn btn-white btn-outline-light"><em className="icon ni ni-file-pdf"></em><span>خروجی PDF</span></a>
                                            </li>
                                            <li>
                                                <a onClick={e => this.getExcels(e)} className="btn btn-white btn-outline-light"><em className="icon ni ni-file-xls"></em><span>خروجی Excel</span></a>
                                            </li>
                                            <li>
                                                <NavLink to="/banktransaction/upload/" className="btn btn-white btn-outline-light"><em className="icon ni ni-download-cloud"></em><span>ورود اکسل اطلاعات</span></NavLink>
                                            </li>
                                            <li>
                                                <a className="hand btn btn-primary" onClick={this.handleShowModal}>
                                                    <em className="icon ni ni-download-cloud"></em><span>افزودن تراکنش جدید</span>
                                                </a>
                                            </li>
                                            <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>افزودن تراکنش جدید</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <Form>
                                                        <Form.Group controlId="formDate">
                                                            <Form.Label>تاریخ</Form.Label>
                                                            <Form.Control type="date" value={this.state.date} onChange={(e) => this.setState({ date: e.target.value })} />
                                                        </Form.Group>
                                                        <Form.Group controlId="formReceiver">
                                                            <Form.Label>دریافت کننده</Form.Label>
                                                            <Form.Control type="text" placeholder="نام دریافت‌کننده" value={this.state.receiver} onChange={(e) => this.setState({ receiver: e.target.value })} />
                                                        </Form.Group>
                                                    </Form>
                                                </Modal.Body>
                                                <Modal.Footer>
                                                    <Button variant="danger" onClick={this.handleCloseModal}>لغو</Button>
                                                    <Button variant="primary" onClick={this.handleSave}>ذخیره</Button>
                                                </Modal.Footer>
                                            </Modal>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="nk-block">
                        <div className="card card-bordered card-stretch">
                            <div className="card-inner p-0">
                                <DataTable
                                    columns={columns}
                                    data={this.state.data.records}
                                    noHeader
                                    highlightOnHover
                                    customStyles={customStyles}
                                />


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {/*this.isEmptyAnnualsOrCompanies(this.state.data.global) ? this.renderNoCompanyOrAnnualRegister() :*/ this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}
